import { ConfirmDialog } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface DeleteMeetingTopicDialogProps {
    isOpen: boolean;
    subject: string;
    /** Whether the message also warns that the topic's notes go with it. */
    hasNotes: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    dataTestId: string;
}

export const DeleteMeetingTopicDialog = ({
    isOpen,
    subject,
    hasNotes,
    onConfirm,
    onCancel,
    dataTestId,
}: DeleteMeetingTopicDialogProps) => {
    const { t } = useAmelioTranslations();

    return (
        <ConfirmDialog
            isOpen={isOpen}
            title={t('managerAssessmentEvaluation.meetingTopics.deleteTitle')}
            message={t(
                hasNotes
                    ? 'managerAssessmentEvaluation.meetingTopics.deleteMessageWithNotes'
                    : 'managerAssessmentEvaluation.meetingTopics.deleteMessage',
                { subject },
            )}
            confirmLabel={t('common.delete')}
            cancelLabel={t('common.cancel')}
            onConfirm={onConfirm}
            onCancel={onCancel}
            isDestructive
            dataTestId={dataTestId}
        />
    );
};
